import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import { EUserType } from '../../constants/requestDemand';
import { trackSmsBack } from '../../components/demand/utils/tracking';
import { closeDemandSmsVerificationModal } from './requestDemand';

export const returnBackToForm = (): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    const {
      requestDemand: { selectedUserType },
    } = getState();
    const isHomeOwner = selectedUserType === EUserType.HOME_OWNER;

    dispatch(closeDemandSmsVerificationModal());

    trackSmsBack(isHomeOwner);
  };
};
